/*
 * @FilePath: \kitchen-online-web\src\redux\reducers\mesa.js
 * @Author: Yu Wang
 * @Date: 2021-08-07 14:15:33
 * @LastEditors: Yu Wang
 * @LastEditTime: 2021-08-23 20:22:31
 */
const mesaAction = {
  'mesa-list': (state, payload) => ({ // 台面信息
    ...state,
    mesaList: { ...payload },
  }),
  mesaScreen: (state, payload) => ({ // 顶柜筛选信息
    ...state,
    mesaScreen: { ...payload },
  }),
};

export default mesaAction;
